import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { BasicModalV2, TextButton } from '../../../../components/index.js';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader.tsx';
import CustomTable from '../../../Common/customComponents/CustomTable.tsx';
import CustomSelectSingle from '../../../Common/customComponents/CustomSelectSingle.tsx';
import CustomText from '../../../Common/customComponents/CustomText.tsx';
import { useAsync } from '../../../../hooks/index.js';
import { commonMsg } from 'utils/globalUtil.tsx';
import { tbmManagementApi } from '../../../../api/tbm-management.api.ts';
import { searchablePermitTypeList } from '../index.tsx';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  onActionCallback: (selectedRow: any) => void;
}

const PermitSelectModal = (props: IProps) => {
  const { showAlarm, closeAlarm } = useAsync();
  const [searchData, setSearchData] = useState<any>({});
  const [gridData, setGridData] = useState<any[]>([]);
  const [checkedList, setCheckedList] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [pageSize] = useState<number>(10);

  const handleChange = (e: any) => {
    setSearchData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const search = (pageNum?: number) => {
    const param = {
      ...searchData,
      page: pageNum ?? 1,
      size: pageSize,
      status: 'APPROVED'
    };
    tbmManagementApi.getPtwSelectList(param).then((r: any) => {
      const list = (r?.resultList ?? []).map((row: any, idx: number) => ({
        ...row,
        no: idx + 1 + ((pageNum ?? 1) - 1) * pageSize
      }));
      setGridData(list);
      setTotalCount(r?.resultList?.[0]?.totalCount ?? 0);
    });
  };

  useEffect(() => {
    if (!props.isModalOpen) {
      setSearchData({});
      setGridData([]);
      setCheckedList([]);
      setCurrentPage(1);
      return;
    }
    search(1);
  }, [props.isModalOpen]);

  useEffect(() => {
    if (!props.isModalOpen) return;
    search(1);
  }, [searchData]);

  useEffect(() => {
    if (!props.isModalOpen) return;
    search(currentPage);
  }, [currentPage]);

  const setSingleCheckData = (updater: any) => {
    setGridData((prev: any[]) => {
      const next: any[] = typeof updater === 'function' ? updater(prev) : updater;
      const newlyChecked = next.find((row: any, i: number) => row.isCheck && !prev[i]?.isCheck);
      if (newlyChecked) {
        return next.map((row: any) => ({ ...row, isCheck: row === newlyChecked }));
      }
      return next;
    });
  };

  const columns = [
    { column: 'no', label: 'No', align: 'center', size: 60 },
    { column: 'ptwNo', label: 'PTW No', align: 'center', size: 160 },
    { column: 'certificateNo', label: 'Certificate No', align: 'center', size: 160 },
    {
      column: 'smartHook',
      label: 'Hook',
      align: 'center',
      size: 120,
      type: 'custom',
      custom: (row: any) => row.smartHook ?? 0
    }
  ];

  const onOk = () => {
    if (checkedList.length === 0) {
      commonMsg.alert(showAlarm, closeAlarm, 'Warning', 'Please select a PTW.', null);
      return;
    }
    props.onActionCallback(checkedList[0]);
    props.setIsModalOpen(false);
  };

  return (
    <BasicModalV2 open={props.isModalOpen} onClose={() => props.setIsModalOpen(false)}>
      <CustomModalHeader title="PTW Selected" modalClose={() => props.setIsModalOpen(false)} />
      <div className="custom-modal-body" style={{ width: '700px', height: '700px' }}>
        <div className="search-box pt-0 pb-0">
          <div className="search-item-list">
            <div className="search-item">
              <CustomSelectSingle
                label="Permit Type :"
                labelWidth={100}
                name="formCode"
                onChange={handleChange}
                value={searchData?.formCode}
                selectWidth={300}
                options={searchablePermitTypeList}
                nullLabel="ALL"
              />
            </div>
            <div className="search-item">
              <CustomText
                name="searchText"
                value={searchData?.searchText ?? ''}
                onChange={handleChange}
                placeholder="Enter search query."
                isBtnSearch={true}
                isBtnClose={true}
              />
            </div>
          </div>
        </div>
        <div className="grid-box">
          <CustomTable
            columns={columns}
            data={gridData}
            setData={setSingleCheckData}
            isPaging={true}
            isCheck={true}
            pageSize={pageSize}
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            checkedList={checkedList}
            setCheckedList={setCheckedList}
            className="min-w-100"
            bodyHeight={430}
          />
        </div>
        <div className="button-box" style={{ marginTop: '16px' }}>
          <TextButton
            className="cancel-style"
            variant="outlined"
            style={{ height: '40px' }}
            onClick={() => props.setIsModalOpen(false)}
          >
            Close
          </TextButton>
          <TextButton variant="contained" style={{ height: '40px' }} onClick={onOk}>
            OK
          </TextButton>
        </div>
      </div>
    </BasicModalV2>
  );
};

export default PermitSelectModal;
